function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AuthProviders } from '@/types/server';
import twitchModNightbotDark from '@/assets/nightbot/TwitchModNightbotDark.png';
import twitchModNightbotLight from '@/assets/nightbot/TwitchModNightbotLight.png';
import youtubeModNightbotDark from '@/assets/nightbot/YoutubeModNightbotDark.png';
import youtubeModNightbotLight from '@/assets/nightbot/YoutubeModNightbotLight.png';
import trovoModNightbot from '@/assets/nightbot/TrovoModNightbot.png';
import noiceModNightbot from '@/assets/nightbot/NoiceModNightbot.png';
import soopModNightbot from '@/assets/nightbot/SoopModNightbot.png';
import { Anchor, Code, Image, List, Text } from '@mantine/core';
import { ExternalUrls } from '@/utils/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { CopyTextButton } from './CopyTextButton';
import styles from './AuthProviderSteps.module.scss';
import useColorModeValue from '@/hooks/useColorModeValue';
function TwitchOnboardingSteps(param) {
    var channel = param.channel;
    var intl = useIntl();
    var imageSrc = useColorModeValue(twitchModNightbotLight, twitchModNightbotDark);
    if ((channel === null || channel === void 0 ? void 0 : channel.provider) !== AuthProviders.TWITCH) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(List, {
        type: "ordered",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.disclaimer,
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "rsS/s7",
                        defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "YZ2ML1",
                    defaultMessage: "Go to your <link>chat</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Anchor, {
                                href: ExternalUrls.TWITCH_CHAT(channel.name),
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "NvNY3Z",
                    defaultMessage: "Type <code>/mod nightbot</code> into your chat.",
                    values: {
                        code: function(text) {
                            return /*#__PURE__*/ _jsx(Code, {
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: imageSrc,
                    alt: intl.formatMessage({
                        id: "X18/jH",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Twitch Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "PFcTwa",
                    defaultMessage: "If done successfully, you may close this window."
                })
            })
        ]
    });
}
function YoutubeOnboardingSteps() {
    var intl = useIntl();
    var imageSrc = useColorModeValue(youtubeModNightbotLight, youtubeModNightbotDark);
    return /*#__PURE__*/ _jsxs(List, {
        type: "ordered",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.disclaimer,
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "rsS/s7",
                        defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "BepazE",
                    defaultMessage: "Go to your YouTube <link>Community Settings</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Anchor, {
                                href: ExternalUrls.YOUTUBE_COMMUNITY_SETTINGS,
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(CopyTextButton, {
                buttonProps: {
                    className: styles.copyButton
                },
                value: ExternalUrls.YOUTUBE_NIGHTBOT_CHANNEL
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "v+JIWW",
                    defaultMessage: "Copy the URL above, and paste into managing moderators."
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: imageSrc,
                    alt: intl.formatMessage({
                        id: "Am2RRF",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Youtube Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "RLf5Qf",
                    defaultMessage: "Remember to click <b>Save</b>!",
                    values: {
                        b: function(text) {
                            return /*#__PURE__*/ _jsx("b", {
                                children: text
                            }, "bold");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "L6hbwp",
                    defaultMessage: "Go <b>Live</b>, as Nightbot will only join active streams on Youtube.",
                    values: {
                        b: function(text) {
                            return /*#__PURE__*/ _jsx("b", {
                                children: text
                            }, "bold");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.footer,
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "CDnaZB",
                        defaultMessage: "Nightbot may take up to 5 minutes to join your channel. And will not connect if the stream is unlisted or private."
                    })
                })
            })
        ]
    });
}
function TrovoOnboardingSteps() {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(List, {
        type: "ordered",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.disclaimer,
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "rsS/s7",
                        defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "YB7wca",
                    defaultMessage: "Go to your <link>Roles Manager</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Anchor, {
                                href: ExternalUrls.TROVO_STUDIO_ROLES_MANAGE,
                                children: text
                            }, "trovoStudioRolesManageLink");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "9xwraa",
                    defaultMessage: "Search and add <code>Nightbot</code> to the moderator role.",
                    values: {
                        code: function(text) {
                            return /*#__PURE__*/ _jsx(Code, {
                                children: text
                            }, "code");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: trovoModNightbot,
                    alt: intl.formatMessage({
                        id: "CsGtXl",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Trovo Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "sRXEGR",
                    defaultMessage: "Click <b>Save</b> to apply the changes.",
                    values: {
                        b: function(text) {
                            return /*#__PURE__*/ _jsx("b", {
                                children: text
                            }, "bold");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "PFcTwa",
                    defaultMessage: "If done successfully, you may close this window."
                })
            })
        ]
    });
}
function NoiceOnboardingSteps() {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(List, {
        type: "ordered",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.disclaimer,
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "rsS/s7",
                        defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "3+jXKw",
                    defaultMessage: "Go to your <link>Noice Studio</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Anchor, {
                                href: ExternalUrls.NOICE_STUDIO,
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "at1idQ",
                    defaultMessage: "Click on <b>Settings</b> and then <b>Moderation</b>.",
                    values: {
                        b: function(text) {
                            return /*#__PURE__*/ _jsx("b", {
                                children: text
                            }, "bold");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: noiceModNightbot,
                    alt: intl.formatMessage({
                        id: "CEPCUQ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Noice Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "9NSElW",
                    defaultMessage: "Search and add <code>Nightbot</code> to the moderator list.",
                    values: {
                        code: function(text) {
                            return /*#__PURE__*/ _jsx(Code, {
                                children: text
                            }, "code");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "PFcTwa",
                    defaultMessage: "If done successfully, you may close this window."
                })
            })
        ]
    });
}
function SoopOnboardingSteps() {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(List, {
        type: "ordered",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.disclaimer,
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "rsS/s7",
                        defaultMessage: "Ensure that you have modded Nightbot in your channel. If Nightbot is not a moderator, it cannot function properly."
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "pkJPAH",
                    defaultMessage: "Go to your <link>Soop Dashboard</link>.",
                    values: {
                        link: function(text) {
                            return /*#__PURE__*/ _jsx(Anchor, {
                                href: ExternalUrls.SOOP_DASHBOARD_MANAGER,
                                children: text
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "UzhDMB",
                    defaultMessage: "Click on <b>My Channel</b> and then <b>Moderators</b>.",
                    values: {
                        b: function(text) {
                            return /*#__PURE__*/ _jsx("b", {
                                children: text
                            }, "bold");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageContainer,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: soopModNightbot,
                    alt: intl.formatMessage({
                        id: "FcGOu0",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Soop Mod Nightbot"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "r1mx/Z",
                    defaultMessage: "Search and add <code>nightbotapp</code> to the assigned moderator list.",
                    values: {
                        code: function(text) {
                            return /*#__PURE__*/ _jsx(Code, {
                                children: text
                            }, "code");
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(List.Item, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "PFcTwa",
                    defaultMessage: "If done successfully, you may close this window."
                })
            })
        ]
    });
}
var _obj;
var AuthProviderBySteps = (_obj = {}, _define_property(_obj, AuthProviders.TWITCH, TwitchOnboardingSteps), _define_property(_obj, AuthProviders.TROVO, TrovoOnboardingSteps), _define_property(_obj, AuthProviders.NOICE, NoiceOnboardingSteps), _define_property(_obj, AuthProviders.YOUTUBE, YoutubeOnboardingSteps), _define_property(_obj, AuthProviders.SOOP, SoopOnboardingSteps), _obj);
export default function AuthProviderSteps(param) {
    var channel = param.channel;
    var _channel_provider;
    var AuthProviderSteps = AuthProviderBySteps[(_channel_provider = channel === null || channel === void 0 ? void 0 : channel.provider) !== null && _channel_provider !== void 0 ? _channel_provider : AuthProviders.TWITCH];
    return AuthProviderSteps != null ? /*#__PURE__*/ _jsx(AuthProviderSteps, {
        channel: channel
    }) : null;
}
